import { Menu } from "@ark-ui/react";
import type { ComponentProps } from "react";

type Props = ComponentProps<typeof Menu.TriggerItem>;

const TriggerItem = ({ children, ...rest }: Props) => {
  return <Menu.TriggerItem {...rest}>{children}</Menu.TriggerItem>;
};

export default TriggerItem;
